<section class="section white-100">
  <div class="section-container-inside">
    <!-- <h2 class="section-heading mar-b-32" *ngIf="storiesHeader" [innerHtml]="storiesHeader | toHtml"></h2> -->
    <!-- ================================ -->
    <div class="new_item_wrapper pt-4" *ngIf="storiesData?.length">
      <div class="flex-col gap-48">
        <div class="multi-row-grid">
          <div
            class="blog-container"
            *ngFor="let item of storiesData | slice: (page - 1) * 6 : page * 6"
          >
            <ng-container
              *ngTemplateOutlet="figureTemplate; context: { item: item }"
            ></ng-container>
          </div>
        </div>

        <div class="single-row-scroll">
          <div
            class="item"
            *ngFor="let item of storiesData | slice: (page - 1) * 6 : page * 6"
          >
            <ng-container
              *ngTemplateOutlet="figureTemplate; context: { item: item }"
            ></ng-container>
          </div>
        </div>
        <div class="responsive-pagination-wrapper" *ngIf="isPagination">
          <sw-pagination
            [total]="storiesData.length"
            [showNumberOfItems]="6"
            (onPageChange)="onchangePageSize($event)"
            aria-label="Default pagination"
          >
          </sw-pagination>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #figureTemplate let-item="item">
  <div class="blog-container-mobile" *ngIf="item?.fields">
    <div class="blog-image">
      <img
        class="responsive-radius-xl"
        src="{{
          item?.fields?.customerStoryHeroPanel?.fields?.image?.[0]?.fields?.file
            ?.url
        }}"
        alt="{{
          item?.fields?.customerStoryHeroPanel?.fields?.image?.[0]?.fields?.title
        }}"
      />
    </div>
    <div class="latest-news-content">
      <h5 class="latest-news-heading">
        {{ item.fields.customerStoryHeroPanel.fields.title }}
      </h5>
    </div>
    <a
      href="{{ 'about-us/media-and-events/customer-stories/' + item.fields.webPageId | urlParams:queryParams }}"
      class="stretched-link"
      (click)="onCaseStudyClick(item.fields.customerStoryHeroPanel.fields.title, item.fields.customerStoryHeroPanel.fields.title, 'about-us/media-and-events/customer-stories/' + item.fields.webPageId)"
    ></a>
    </div>
</ng-template>
